import { GalleryApi } from '@liks/backend-svc-api/esm/apis/GalleryApi';
import type {
  GalleryImageWithIdentity,
  GalleryListOptions,
} from '../types/gallery';
import { backendApiConfiguration } from './backendApi';

export type {
  GalleryImageWithIdentity,
  GalleryListOptions,
} from '../types/gallery';

function hasId<T extends { id?: string | null }>(
  value: T,
): value is T & { id: string } {
  return typeof value.id === 'string' && value.id.length > 0;
}

class GalleryService {
  private readonly galleryApi = new GalleryApi(backendApiConfiguration);

  async listImages(
    listOptions: GalleryListOptions,
  ): Promise<GalleryImageWithIdentity[]> {
    const images =
      await this.galleryApi.deLiksPlatformchatBoundaryGalleryImageResourceListGalleryImages(
        {
          offset: listOptions.offset,
          limit: listOptions.limit,
          query: listOptions.query,
        },
      );

    return images.filter(hasId);
  }

  async downloadImageData(imageId: string): Promise<Blob> {
    const response =
      await this.galleryApi.deLiksPlatformchatBoundaryGalleryImageResourceDownloadGalleryImageRaw(
        { id: imageId },
      );
    return response.raw.blob();
  }

  async deleteImage(imageId: string): Promise<void> {
    // Generated client expects JSON (LiksFailures), but the API returns 204 with
    // an empty body — parsing that fails even though delete succeeded.
    await this.galleryApi.deLiksPlatformchatBoundaryGalleryImageResourceDeleteGalleryImageRaw(
      { id: imageId },
    );
  }

  async addImage(imageId: string): Promise<void> {
    await this.galleryApi.deLiksPlatformchatBoundaryGalleryImageResourceAddGalleryImage(
      { id: imageId },
    );
  }
}

export const galleryService = new GalleryService();
